import { Gql } from '@fiverr-private/dynamic_matching';
import { Range } from '../../../../types/range';

export interface BudgetAndTimelineContent {
    pricingType: Gql.BriefPricingType | null;
    budgetInCents?: number;
    hourlyBudgetRange?: Range<number>;
    timeline?: Gql.DmBriefTimeline;
    deliveryDate?: number;
    timelineDetails?: {
        generalTimeline?: TimeUnitAndValue;
        timeCommitment?: TimeCommitmentType;
        hiringDuration?: HiringDurationType;
        deliveriesFrequency?: TimeUnitAndValue;
    };
    ongoingWorkPotential?: boolean;
}

export const timeUnits = {
    days: 'days',
    weeks: 'weeks',
    months: 'months',
} as const;

export type TimeUnit = (typeof timeUnits)[keyof typeof timeUnits];

export const apiTimeUnits = {
    days: 'DAY',
    weeks: 'WEEK',
    months: 'MONTH',
} as const;

export type ApiTimeUnit = (typeof apiTimeUnits)[keyof typeof apiTimeUnits];

export const mapTimeUnitsToApiTimeUnit = (timeUnit: TimeUnit): ApiTimeUnit => apiTimeUnits[timeUnit];

export interface TimeUnitAndValue {
    unit?: TimeUnit;
    value?: number;
}

export const durations = {
    moreThanThreeMonths: 'more_than_three_months',
    oneToThreeMonths: 'one_to_three_months',
    lessThanOneMonth: 'less_than_one_month',
} as const;

export type HiringDurationType = (typeof durations)[keyof typeof durations];

export const timeCommitments = {
    overThirtyHoursPerWeek: 'over_thirty_hours_per_week',
    tenToThirtyHoursPerWeek: 'ten_to_thirty_hours_per_week',
    upToTenHoursPerWeek: 'up_to_ten_hours_per_week',
} as const;

export type TimeCommitmentType = (typeof timeCommitments)[keyof typeof timeCommitments];
